export const environment = {
  production: true,
  bypassOktaForLocal: false,
  federatedProvider: 'Okta',
  apiUrl: 'https://mpgpsr-dev.spe.sony.com/app/api',
  reportUrl: 'https://mpgpsr-dev.spe.sony.com/app/report',
  baseUrl: 'https://mpgpsr-dev.spe.sony.com',
  config: {
    Auth: {
      Cognito: {
        userPoolId: 'us-west-2_dUb1sQq10',
        userPoolClientId: '6p3uepqf743tdfprg18tq4mlv4',
        loginWith: {
          oauth: {
            domain: 'mpgpsr-domain-dev.auth.us-west-2.amazoncognito.com',
            scopes: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
            redirectSignIn: ['https://mpgpsr-dev.spe.sony.com/'],
            redirectSignOut: ['https://login.spe.sony.com'],
            responseType: 'code' as const,
            providers: [{ custom: 'Okta' }]
          }
        }
      }
    }
  }
};
